export default {
	"order.TheSystemIsOutOfOrder": "系統開小差啦",
	"order.AlipayScanCodeSigningContract": "支付寶掃碼簽約",
	"order.PayAndSignUp": "支付並簽約",
	"order.GoToAlipayToSignAContract": "前往支付寶簽約"
}